/* ============================================================================
   L9 · Configurador de grabado laser — Joyeria Lady

   Decisiones que conviene no perder:
   - Los simbolos son VECTORES, no glifos ni emoji: en un laser no hay color,
     hay trazo. Se dibujan como <use> posicionados sobre la curva.
   - No se usa API key de Google Fonts. El catalogo viene de un JSON servido
     por el CDN de la tienda.
   - Se verifica que la fuente contenga de verdad cada caracter escrito.
   - El mensaje de WhatsApp se arma codificando linea por linea y uniendo con
     %0A, para no depender de literales de salto de linea en el codigo.
   - Cada familia se pide UNA vez con un juego fijo de caracteres (JUEGO).

   🔴 EL ENCUADRE SE MIDE EN MILIMETROS, NO EN ALTURAS DE LETRA (20 sep 2026)
   Lo encontro Paul: puso un anillo de dama de 1,8 mm y uno de caballero de
   4 mm y dijo "la letra se ve exactamente igual". Tenia razon. El encuadre
   usaba `fs * 9`, o sea nueve alturas de letra: si la letra crecia, la ventana
   crecia lo mismo y la diferencia se cancelaba sola. Medido en la pagina antes
   de tocar nada: 34,9 px de letra en los DOS anillos, con 0,85 mm y 1,75 mm de
   altura real. Lo unico que cambiaba era la regla de 1 mm (41,1 px contra
   20,0 px), un detalle que nadie mira.
   Ahora la ventana se ancla a MILIMETROS DE ANILLO. Una letra de 0,85 mm ocupa
   de verdad la mitad que una de 1,75 mm. NO volver a atar el encuadre al
   tamano de letra.
   Limite honesto que queda: con textos largos la ventana tiene que crecer para
   que quepa el texto, y entonces las dos vistas vuelven a parecerse. Por eso
   ademas se imprime la altura en milimetros debajo del dibujo — ese numero no
   depende del encuadre.

   FASE 1c — UNO O DOS ANILLOS (19 sep 2026)
   El estado es una LISTA de anillos. La letra es compartida; el ancho, la
   talla y la superficie son siempre de cada anillo. El conmutador vive junto a
   la vista previa y lleva un punto de aviso cuando el OTRO anillo tiene algo
   que revisar. El precio es precio x cantidad.

   EL CODIGO GL-
   GL-DDMMYY-HHMMSS — fecha y hora exacta. No es aleatorio: un contador de
   verdad necesitaria servidor y ademas se lo comerian los bots. El correlativo
   del PEDIDO lo asigna L1 en Google Sheets.

   LIMITE DE TEXTO (Paul, 5 sep 2026)
   20 caracteres, maximo BLANDO: nunca bloquea el envio.

   VISTA UNICA (Paul, 19 sep 2026)
   Solo la vista ampliada. Los botones siguen en el HTML ocultos por CSS.

   ENCABEZADO PEGAJOSO DEL TEMA
   La altura NO se codifica: se mide y se publica como la variable CSS --gl-top.

   FALLO CORREGIDO EL 19 SEP 2026 — el ancho del anillo no hacia nada
   El <select> de ancho lleva `data-gl-banda`, pero en el SVG hay un
   <path data-gl-banda> que va ANTES en el HTML. Por eso los controles se
   buscan como `select[data-gl-...]`. NO QUITAR el `select`.
   ========================================================================= */
(function () {
  'use strict';

  var SIMBOLOS = { '❤': 'corazon', '∞': 'infinito', '★': 'estrella' };
  var CX = 200, CY = 200, R_INT = 118;
  var CAT = { s: 'Sans', r: 'Serif', d: 'Display', h: 'Manuscrita' };
  var JUEGO = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789 .,;:&-_/()'!?+*áéíóúüñÁÉÍÓÚÜÑ¿¡";
  var SUPERFICIES = { liso: '', piedras: 'Con piedras arriba', eternity: 'Piedras en todo el contorno' };
  /* Milimetros de anillo que muestra la ventana cuando el texto es corto.
     Subirlo aleja la camara; bajarlo la acerca. Con 6 mm una letra de 0,85 mm
     se ve a la mitad que una de 1,75 mm, que es la proporcion real. */
  var VENTANA_MM = 6;

  var cargadas = Object.create(null);
  var lienzo = null;

  function q(raiz, sel) { return raiz.querySelector(sel); }
  function qa(raiz, sel) { return Array.prototype.slice.call(raiz.querySelectorAll(sel)); }
  function num(v, alt) { var n = parseFloat(v); return isFinite(n) ? n : alt; }
  function mm(v) { return String(v).replace('.', ','); }
  function sinSimbolos(s) { var o = ''; for (var i = 0; i < s.length; i++) { if (!SIMBOLOS[s[i]]) o += s[i]; } return o; }
  function limpio(s) { return (s || '').replace(/\s+/g, ' ').trim(); }

  function altoTapa() {
    if (!document.elementsFromPoint) return 0;
    var cx = Math.max(1, Math.floor(window.innerWidth / 2));
    var els = document.elementsFromPoint(cx, 2) || [];
    var tope = 0, limite = window.innerHeight * 0.4;
    for (var i = 0; i < els.length; i++) {
      var el = els[i];
      if (!el || el === document.body || el === document.documentElement) continue;
      if (el.closest && el.closest('[data-gl]')) continue;
      var pos = '';
      try { pos = window.getComputedStyle(el).position; } catch (x) { continue; }
      if (pos !== 'fixed' && pos !== 'sticky') continue;
      var b = el.getBoundingClientRect().bottom;
      if (b > tope && b <= limite) tope = b;
    }
    return Math.round(tope);
  }

  var topeActual = -1;
  function ajustarTope() {
    var t = altoTapa();
    if (t === topeActual) return;
    topeActual = t;
    qa(document, '[data-gl]').forEach(function (r) { r.style.setProperty('--gl-top', t + 'px'); });
  }

  function cargarFuente(familia, texto) {
    var vistos = Object.create(null), lista = [];
    function meter(s) {
      for (var i = 0; i < s.length; i++) {
        var c = s[i];
        if (SIMBOLOS[c] || vistos[c]) continue;
        vistos[c] = 1; lista.push(c);
      }
    }
    meter(JUEGO); meter(texto || '');
    lista.sort();
    var chars = lista.join('');
    var clave = familia + '|' + chars;
    if (cargadas[clave]) return cargadas[clave];
    var href = 'https://fonts.googleapis.com/css2?family=' +
      encodeURIComponent(familia).replace(/%20/g, '+') +
      '&text=' + encodeURIComponent(chars) + '&display=swap';
    cargadas[clave] = new Promise(function (res) {
      var l = document.createElement('link');
      l.rel = 'stylesheet'; l.href = href;
      l.onload = l.onerror = function () {
        var esperar = document.fonts && document.fonts.load
          ? document.fonts.load('16px "' + familia + '"', chars)['catch'](function () {})
          : Promise.resolve();
        Promise.resolve(esperar).then(function () { res(); });
      };
      document.head.appendChild(l);
    });
    return cargadas[clave];
  }

  function glifosFaltantes(familia, texto) {
    if (!lienzo) lienzo = document.createElement('canvas').getContext('2d');
    var falta = [], vistos = Object.create(null);
    function ancho(f, ch) { lienzo.font = f; return lienzo.measureText(ch).width; }
    for (var i = 0; i < texto.length; i++) {
      var c = texto[i];
      if (SIMBOLOS[c] || c === ' ' || vistos[c]) continue;
      vistos[c] = 1;
      var a1 = ancho('64px "' + familia + '", monospace', c), b1 = ancho('64px monospace', c);
      var a2 = ancho('64px "' + familia + '", serif', c), b2 = ancho('64px serif', c);
      if (Math.abs(a1 - b1) < 0.02 && Math.abs(a2 - b2) < 0.02) falta.push(c);
    }
    return falta;
  }

  /* GL-DDMMYY-HHMMSS — dia, mes, ano, hora, minuto, segundo. Sin azar. */
  function nuevoId() {
    var d = new Date();
    function dos(n) { return ('0' + n).slice(-2); }
    return 'GL-' + dos(d.getDate()) + dos(d.getMonth() + 1) + dos(d.getFullYear() % 100) +
      '-' + dos(d.getHours()) + dos(d.getMinutes()) + dos(d.getSeconds());
  }

  function nuevoAnillo(ident, banda) {
    return { texto: '', talla: '7', banda: banda, superficie: 'liso', ident: ident };
  }

  function persistirDiseno() { return Promise.resolve(null); }

  function Config(raiz) {
    this.raiz = raiz;
    this.cfg = JSON.parse(q(raiz, '[data-gl-config]').textContent);
    this.max = num(this.cfg.maxCaracteres, 20);
    this.id = nuevoId();
    this.muestraActual = '';
    this.estado = {
      pieza: 'anillo-interior',
      cantidad: 1,
      mismoTexto: true,
      activo: 0,
      fuente: null,
      anillos: [ nuevoAnillo('', 2), nuevoAnillo('Anillo de caballero', 4) ]
    };
    this.svg = q(raiz, '[data-gl-svg]');
    raiz.dataset.vista = 'zoom';

    /* Lectura en milimetros bajo el dibujo. El encuadre se acerca o se aleja
       segun el texto, asi que el dibujo por si solo no deja comparar tamanos
       entre un anillo y otro; este numero si. */
    var inner = q(raiz, '.gl__stage-inner');
    if (inner) {
      this.lectura = document.createElement('p');
      this.lectura.className = 'gl__escala';
      this.lectura.setAttribute('data-gl-escala', '');
      var nota = q(inner, '.gl__nota');
      if (nota) inner.insertBefore(this.lectura, nota); else inner.appendChild(this.lectura);
    }

    this.enlazar();
    this.pintarFavoritas();
    this.pintarTallas();
    this.sincronizarUI();
    this.render();
  }

  Config.prototype.anillo = function () { return this.estado.anillos[this.estado.activo]; };

  Config.prototype.enlazar = function () {
    var self = this, r = this.raiz;
    q(r, '[data-gl-texto-input]').addEventListener('input', function (e) {
      self.escribir(e.target.value);
    });
    qa(r, '[data-gl-sim]').forEach(function (b) {
      b.addEventListener('click', function () {
        var ch = Object.keys(SIMBOLOS).filter(function (k) { return SIMBOLOS[k] === b.dataset.glSim; })[0];
        self.insertar(ch);
      });
    });
    qa(r, '[data-gl-char]').forEach(function (b) {
      b.addEventListener('click', function () { self.insertar(b.dataset.glChar); });
    });
    qa(r, '[data-gl-vista]').forEach(function (b) {
      b.addEventListener('click', function () {
        r.dataset.vista = b.dataset.glVista;
        qa(r, '[data-gl-vista]').forEach(function (o) { o.setAttribute('aria-pressed', String(o === b)); });
        self.render();
      });
    });
    qa(r, '[data-gl-pieza]').forEach(function (el) {
      el.addEventListener('change', function () {
        if (el.checked) { self.estado.pieza = el.value; self.render(); }
      });
    });
    qa(r, '[data-gl-cantidad]').forEach(function (el) {
      el.addEventListener('change', function () {
        if (el.checked) self.cambiarCantidad(parseInt(el.value, 10) === 2 ? 2 : 1);
      });
    });
    qa(r, '[data-gl-tab]').forEach(function (b) {
      b.addEventListener('click', function () { self.activar(parseInt(b.dataset.glTab, 10) || 0); });
    });
    var mismo = q(r, '[data-gl-mismo]');
    if (mismo) mismo.addEventListener('change', function () {
      self.estado.mismoTexto = !!mismo.checked;
      if (self.estado.mismoTexto) {
        var t = self.anillo().texto;
        self.estado.anillos[0].texto = t;
        self.estado.anillos[1].texto = t;
      }
      self.render();
    });
    /* `select[...]` a proposito: ver el fallo del 19 sep 2026 en la cabecera. */
    ['talla', 'banda', 'superficie', 'ident'].forEach(function (k) {
      var el = q(r, 'select[data-gl-' + k + ']');
      if (el) el.addEventListener('change', function (e) {
        self.anillo()[k] = k === 'banda' ? num(e.target.value, 2) : e.target.value;
        self.render();
      });
    });
    var tg = q(r, '[data-gl-toggle-explorar]');
    if (tg) tg.addEventListener('click', function () {
      var caja = q(r, '[data-gl-explorar]'), abierto = caja.hidden;
      caja.hidden = !abierto;
      tg.setAttribute('aria-expanded', String(abierto));
      if (abierto) self.cargarCatalogo();
    });
    var busq = q(r, '[data-gl-buscar]');
    if (busq) busq.addEventListener('input', function () { self.filtrar(); });
    qa(r, '[data-gl-cat]').forEach(function (b) {
      b.addEventListener('click', function () {
        qa(r, '[data-gl-cat]').forEach(function (o) { o.setAttribute('aria-pressed', String(o === b)); });
        self.cat = b.dataset.glCat; self.filtrar();
      });
    });
  };

  Config.prototype.escribir = function (v) {
    var e = this.estado;
    this.anillo().texto = v;
    if (e.cantidad === 2 && e.mismoTexto) e.anillos[1 - e.activo].texto = v;
    this.render();
  };

  Config.prototype.cambiarCantidad = function (n) {
    var e = this.estado;
    e.cantidad = n;
    if (n === 1) {
      e.activo = 0;
    } else {
      if (!e.anillos[0].ident) e.anillos[0].ident = 'Anillo de dama';
      if (e.mismoTexto) e.anillos[1].texto = e.anillos[0].texto;
    }
    this.sincronizarUI();
    this.sincronizarCampos();
    this.render();
  };

  Config.prototype.activar = function (i) {
    var e = this.estado;
    if (i === e.activo || i >= e.cantidad) return;
    e.activo = i;
    this.sincronizarUI();
    this.sincronizarCampos();
    this.render();
  };

  Config.prototype.sincronizarCampos = function () {
    var r = this.raiz, a = this.anillo();
    var inp = q(r, '[data-gl-texto-input]');
    if (inp && inp.value !== a.texto) inp.value = a.texto;
    ['talla', 'banda', 'superficie', 'ident'].forEach(function (k) {
      var el = q(r, 'select[data-gl-' + k + ']');
      if (el) el.value = String(a[k]);
    });
  };

  Config.prototype.sincronizarUI = function () {
    var r = this.raiz, e = this.estado, dos = e.cantidad === 2;
    var tabs = q(r, '[data-gl-tabs]'); if (tabs) tabs.hidden = !dos;
    var mw = q(r, '[data-gl-mismo-wrap]'); if (mw) mw.hidden = !dos;
    var a = e.anillos[e.activo];
    var etiqueta = 'Editando: anillo ' + (e.activo + 1) + (a.ident ? ' · ' + a.ident : '');
    qa(r, '[data-gl-activo]').forEach(function (el) {
      el.hidden = !dos;
      el.textContent = dos ? etiqueta : '';
    });
  };

  Config.prototype.marcarTabs = function () {
    var e = this.estado, self = this;
    qa(this.raiz, '[data-gl-tab]').forEach(function (b, i) {
      var a = e.anillos[i];
      var revisar = limpio(a.texto).length > self.max || a.superficie === 'eternity';
      if (revisar) b.setAttribute('data-aviso', '1'); else b.removeAttribute('data-aviso');
      b.setAttribute('aria-pressed', String(i === e.activo));
    });
  };

  Config.prototype.lecturaMm = function () {
    if (!this.lectura) return;
    var a = this.anillo();
    this.lectura.textContent = 'Altura de la letra: ' + mm(this.altoLetra()) +
      ' mm · anillo de ' + mm(a.banda) + ' mm de ancho';
  };

  Config.prototype.insertar = function (ch) {
    var inp = q(this.raiz, '[data-gl-texto-input]');
    var ini = inp.selectionStart != null ? inp.selectionStart : inp.value.length;
    var fin = inp.selectionEnd != null ? inp.selectionEnd : ini;
    inp.value = inp.value.slice(0, ini) + ch + inp.value.slice(fin);
    inp.focus();
    try { inp.setSelectionRange(ini + ch.length, ini + ch.length); } catch (x) {}
    this.escribir(inp.value);
  };

  Config.prototype.pintarTallas = function () {
    var sel = q(this.raiz, 'select[data-gl-talla]');
    if (!sel) return;
    sel.innerHTML = '<option value="">No la sé</option>' + this.cfg.tallas.map(function (t) {
      return '<option value="' + t.t + '">Talla ' + t.t + '</option>';
    }).join('');
    sel.value = '7';
    this.estado.anillos.forEach(function (a) { a.talla = '7'; });
  };

  Config.prototype.diametro = function () {
    var t = this.anillo().talla || '7';
    var f = this.cfg.tallas.filter(function (x) { return x.t === t; })[0];
    return f ? f.d : 17.3;
  };

  Config.prototype.altoLetra = function () {
    return this.anillo().banda >= num(this.cfg.umbralBanda, 2.5)
      ? num(this.cfg.altoLetraAncha, 1.75) : num(this.cfg.altoLetraFina, 0.85);
  };

  Config.prototype.factorArco = function () {
    var s = this.anillo().superficie;
    if (s === 'eternity') return 0;
    if (s === 'piedras') return num(this.cfg.arcoPiedras, 50) / 100;
    return num(this.cfg.arcoLiso, 85) / 100;
  };

  Config.prototype.filaFuente = function (familia, etiqueta, nota, marcada, ok) {
    var b = document.createElement('button');
    b.type = 'button'; b.className = 'gl__fuente'; b.dataset.familia = familia;
    b.setAttribute('aria-pressed', String(!!marcada));
    b.innerHTML = '<span class="gl__izq"><span class="gl__muestra"></span>' +
      '<span class="gl__nota-f"></span></span>' +
      '<span class="gl__meta' + (ok ? ' gl__meta--ok' : '') + '"></span>';
    var meta = q(b, '.gl__meta');
    meta.appendChild(document.createTextNode(etiqueta || ''));
    var n = document.createElement('span');
    n.className = 'gl__nombre'; n.textContent = familia;
    meta.appendChild(n);
    q(b, '.gl__nota-f').textContent = nota || '';
    return b;
  };

  Config.prototype.pintarFavoritas = function () {
    var self = this, cont = q(this.raiz, '[data-gl-favoritas]');
    cont.innerHTML = '';
    (this.cfg.favoritas || []).forEach(function (f, i) {
      var b = self.filaFuente(f.familia, 'Probada', f.nota, i === 0, true);
      b.addEventListener('click', function () { self.elegirFuente(f.familia); });
      cont.appendChild(b);
      if (i === 0) self.estado.fuente = f.familia;
    });
  };

  Config.prototype.elegirFuente = function (familia) {
    this.estado.fuente = familia;
    qa(this.raiz, '.gl__fuente').forEach(function (b) {
      b.setAttribute('aria-pressed', String(b.dataset.familia === familia));
    });
    this.render();
  };

  Config.prototype.cargarCatalogo = function () {
    var self = this;
    if (this.catalogo) return;
    this.catalogo = [];
    fetch(this.cfg.catalogoUrl).then(function (r) { return r.json(); }).then(function (d) {
      self.catalogo = d.fuentes || []; self.filtrar();
    })['catch'](function () {
      q(self.raiz, '[data-gl-lista]').textContent = 'No se pudo cargar el catálogo. Escribinos por WhatsApp y lo vemos juntos.';
    });
  };

  Config.prototype.filtrar = function () {
    var self = this, lista = q(this.raiz, '[data-gl-lista]');
    if (!lista || !this.catalogo) return;
    var t = (q(this.raiz, '[data-gl-buscar]').value || '').trim().toLowerCase();
    var cat = this.cat || '';
    var res = this.catalogo.filter(function (f) {
      if (cat && f.c !== cat) return false;
      return !t || f.f.toLowerCase().indexOf(t) !== -1;
    }).slice(0, 60);
    lista.innerHTML = '';
    if (!res.length) { lista.textContent = 'Ninguna fuente con ese nombre.'; return; }
    res.forEach(function (f) {
      var b = self.filaFuente(f.f, CAT[f.c] || '', '', f.f === self.estado.fuente, false);
      b.addEventListener('click', function () { self.elegirFuente(f.f); });
      lista.appendChild(b);
    });
    this.observarMuestras(lista);
  };

  Config.prototype.observarMuestras = function (cont) {
    var self = this;
    if (!window.IntersectionObserver) { return; }
    if (!this.observador) {
      this.observador = new IntersectionObserver(function (ents) {
        ents.forEach(function (e) {
          if (!e.isIntersecting) return;
          self.observador.unobserve(e.target);
          var fam = e.target.dataset.familia, sp = q(e.target, '.gl__muestra');
          var m = self.muestraActual || 'Ejemplo';
          sp.textContent = m;
          cargarFuente(fam, m).then(function () { sp.style.fontFamily = '"' + fam + '", serif'; });
        });
      }, { root: cont, rootMargin: '120px' });
    }
    qa(cont, '.gl__fuente').forEach(function (b) { self.observador.observe(b); });
  };

  Config.prototype.pintarMuestrasFav = function () {
    var m = this.muestraActual;
    qa(q(this.raiz, '[data-gl-favoritas]'), '.gl__fuente').forEach(function (b) {
      var fam = b.dataset.familia, sp = q(b, '.gl__muestra');
      sp.textContent = m;
      cargarFuente(fam, m).then(function () { sp.style.fontFamily = '"' + fam + '", serif'; });
    });
  };

  Config.prototype.render = function () {
    var self = this, r = this.raiz, a = this.anillo();
    var texto = a.texto, visible = texto.replace(/\s+/g, ' ');
    var n = limpio(texto).length;
    var cont = q(r, '[data-gl-contador]');
    cont.textContent = n + ' de ' + this.max + ' caracteres';
    if (n > this.max) cont.setAttribute('data-pasado', '1'); else cont.removeAttribute('data-pasado');

    this.muestraActual = limpio(sinSimbolos(texto)) || 'Joyería Lady';
    clearTimeout(this._tMuestras);
    this._tMuestras = setTimeout(function () { self.pintarMuestrasFav(); }, 320);

    var fam = this.estado.fuente || 'serif';
    cargarFuente(fam, visible || 'Aa').then(function () { self.dibujar(fam, visible); });
    this.dibujar(fam, visible);
    this.avisoSuperficie();
    this.lecturaMm();
    this.sincronizarUI();
    this.marcarTabs();
    this.resumen(fam);
  };

  Config.prototype.dibujar = function (fam, texto) {
    var a = this.anillo(), svg = this.svg;
    var D = this.diametro();
    var escala = R_INT / (D / 2);
    var banda = a.banda * escala;
    var rExt = R_INT + banda, rTxt = R_INT + banda / 2;
    var fs = this.altoLetra() * escala;

    q(svg, '[data-gl-aro-ext]').setAttribute('r', rExt.toFixed(2));
    q(svg, '[data-gl-banda]').setAttribute('d',
      'M ' + (CX - rExt) + ',' + CY + ' a ' + rExt + ',' + rExt + ' 0 1,0 ' + (2 * rExt) + ',0 a ' + rExt + ',' + rExt + ' 0 1,0 ' + (-2 * rExt) + ',0 ' +
      'M ' + (CX - R_INT) + ',' + CY + ' a ' + R_INT + ',' + R_INT + ' 0 1,0 ' + (2 * R_INT) + ',0 a ' + R_INT + ',' + R_INT + ' 0 1,0 ' + (-2 * R_INT) + ',0');

    /* Ruta del texto: circulo completo que ARRANCA ARRIBA, de modo que el 50%
       cae exactamente abajo. Asi startOffset="50%" centra el texto en la zona
       que de verdad se graba y ningun glifo queda fuera de la ruta. */
    var pRuta = q(svg, '[data-gl-ruta]');
    pRuta.setAttribute('d', 'M ' + CX + ',' + (CY - rTxt) +
      ' A ' + rTxt + ',' + rTxt + ' 0 0,0 ' + CX + ',' + (CY + rTxt) +
      ' A ' + rTxt + ',' + rTxt + ' 0 0,0 ' + CX + ',' + (CY - rTxt));

    var fac = this.factorArco(), zona = q(svg, '[data-gl-zona]');
    if (zona) {
      if (fac > 0 && fac < 1) {
        var med = Math.PI * fac;
        var a0 = -Math.PI / 2 - med, a1 = -Math.PI / 2 + med;
        var x0 = CX + rTxt * Math.cos(a0), y0 = CY - rTxt * Math.sin(a0);
        var x1 = CX + rTxt * Math.cos(a1), y1 = CY - rTxt * Math.sin(a1);
        zona.setAttribute('d', 'M ' + x0.toFixed(1) + ',' + y0.toFixed(1) +
          ' A ' + rTxt + ',' + rTxt + ' 0 ' + (2 * med > Math.PI ? 1 : 0) + ',0 ' + x1.toFixed(1) + ',' + y1.toFixed(1));
      } else { zona.setAttribute('d', ''); }
    }

    var tEl = q(svg, '[data-gl-texto]'), tp = q(svg, '[data-gl-textpath]');
    tEl.setAttribute('font-size', fs.toFixed(2));
    tEl.setAttribute('font-family', '"' + fam + '", serif');

    var anchoSim = fs * 1.05;
    var partes = this.separar(texto);
    var relleno = this.espaciador(tp, anchoSim, fs);
    tp.textContent = partes.map(function (p) {
      return p.tipo === 'texto' ? p.v : relleno.cadena;
    }).join('');

    var largo = 0;
    try { largo = tp.getComputedTextLength(); } catch (x) { largo = 0; }

    this.colocarSimbolos(pRuta, tp, partes, relleno, anchoSim, largo);
    this.medirTexto(largo, rTxt, escala, D, fac);
    this.encuadre(rTxt, fs, largo);
    q(svg, '[data-gl-svg-title]').textContent =
      texto ? 'Vista previa del grabado: ' + texto : 'Vista previa del grabado';
  };

  Config.prototype.separar = function (texto) {
    var out = [], buf = '';
    for (var i = 0; i < texto.length; i++) {
      var c = texto[i];
      if (SIMBOLOS[c]) {
        if (buf) { out.push({ tipo: 'texto', v: buf }); buf = ''; }
        out.push({ tipo: 'sim', v: SIMBOLOS[c] });
      } else buf += c;
    }
    if (buf) out.push({ tipo: 'texto', v: buf });
    return out;
  };

  Config.prototype.espaciador = function (tp, anchoSim, fs) {
    var previo = tp.textContent, w = 0;
    tp.textContent = '          ';
    try { w = tp.getComputedTextLength() / 10; } catch (x) { w = 0; }
    tp.textContent = previo;
    if (!w || !isFinite(w)) w = fs * 0.28;
    var n = Math.max(2, Math.round(anchoSim / w)), s = '';
    for (var i = 0; i < n; i++) s += ' ';
    return { cadena: s, n: n };
  };

  Config.prototype.colocarSimbolos = function (pRuta, tp, partes, relleno, anchoSim, largoTotal) {
    var g = q(this.svg, '[data-gl-simbolos]');
    g.innerHTML = '';
    if (!partes.some(function (p) { return p.tipo === 'sim'; })) return;
    var largoRuta;
    try { largoRuta = pRuta.getTotalLength(); } catch (x) { return; }
    var inicio = largoRuta / 2 - largoTotal / 2;
    var idx = 0, base = this.raiz.id.replace('gl-', '');
    partes.forEach(function (p) {
      var largo = p.tipo === 'texto' ? p.v.length : relleno.n;
      if (p.tipo === 'sim') {
        var a, b;
        try { a = tp.getSubStringLength(0, idx); b = tp.getSubStringLength(0, idx + largo); }
        catch (x) { idx += largo; return; }
        var off = inicio + (a + b) / 2;
        if (off < 0 || off > largoRuta) { idx += largo; return; }
        var pt = pRuta.getPointAtLength(off);
        var p2 = pRuta.getPointAtLength(Math.min(largoRuta, off + 1));
        var ang = Math.atan2(p2.y - pt.y, p2.x - pt.x) * 180 / Math.PI;
        var u = document.createElementNS('http://www.w3.org/2000/svg', 'use');
        u.setAttribute('href', '#' + base + '-' + p.v);
        u.setAttribute('width', anchoSim.toFixed(2));
        u.setAttribute('height', anchoSim.toFixed(2));
        u.setAttribute('x', (-anchoSim / 2).toFixed(2));
        u.setAttribute('y', (-anchoSim * 0.82).toFixed(2));
        u.setAttribute('transform', 'translate(' + pt.x.toFixed(2) + ',' + pt.y.toFixed(2) + ') rotate(' + ang.toFixed(2) + ')');
        g.appendChild(u);
      }
      idx += largo;
    });
  };

  Config.prototype.medirTexto = function (largo, rTxt, escala, D, fac) {
    var aviso = q(this.raiz, '[data-gl-aviso-largo]');
    if (fac === 0) {
      aviso.setAttribute('data-tono', 'stop');
      aviso.textContent = 'Los anillos con piedras en todo el contorno no se pueden grabar por dentro: la parte de abajo lleva aberturas que dan luz a las piedras. Escribinos y vemos otras opciones — por fuera del anillo, una placa o un dije.';
      return;
    }
    var txt = limpio(this.anillo().texto);
    if (!txt) { aviso.removeAttribute('data-tono'); aviso.textContent = ''; return; }
    var pasaCaracteres = txt.length > this.max;
    var uso = 0;
    if (largo) { uso = ((largo / escala) * (R_INT / rTxt)) / (Math.PI * D * fac); }
    var pasaEspacio = uso > num(this.cfg.umbralAviso, 90) / 100;
    if (pasaCaracteres || pasaEspacio) {
      aviso.setAttribute('data-tono', (txt.length > this.max * 1.6 || uso > 1.15) ? 'stop' : 'warn');
      aviso.textContent = this.cfg.avisoLargo;
    } else { aviso.removeAttribute('data-tono'); aviso.textContent = ''; }
  };

  Config.prototype.avisoSuperficie = function () {
    var a = q(this.raiz, '[data-gl-aviso-superficie]'), s = this.anillo().superficie;
    if (s === 'piedras') {
      a.setAttribute('data-tono', 'info');
      a.textContent = 'En anillos con piedras solo se graba la mitad de abajo del interior, así que entra menos texto.';
    } else if (s === 'eternity') {
      a.setAttribute('data-tono', 'stop');
      a.textContent = 'Este tipo de anillo no se puede grabar por dentro. Escribinos y vemos otra opción.';
    } else { a.removeAttribute('data-tono'); a.textContent = ''; }
  };

  /* 🔴 EL ENCUADRE SE MIDE EN MILIMETROS. Ver la cabecera del archivo.
     La ventana muestra VENTANA_MM milimetros de anillo, y solo se agranda si el
     texto no cabe en ellos. Atarla al tamano de letra (como estaba: `fs * 9`)
     hace que las dos vistas salgan identicas en pantalla. */
  Config.prototype.encuadre = function (rTxt, fs, largo) {
    var reg = q(this.svg, '[data-gl-regla]');
    if (this.raiz.dataset.vista !== 'zoom') {
      this.svg.setAttribute('viewBox', '0 0 400 400'); reg.setAttribute('opacity', '0'); return;
    }
    var escala = R_INT / (this.diametro() / 2);   /* unidades de dibujo por mm */
    var bandaMm = this.anillo().banda;
    var largoMm = (largo || 0) / escala;
    /* El tercer termino evita que una banda ancha llene el cuadro de lado a
       lado y se pierdan los bordes curvos que hacen que parezca un anillo. */
    var anchoMm = Math.max(largoMm * 1.10 + 2.2, num(this.cfg.ventanaMm, VENTANA_MM), bandaMm * 1.6);
    var altoMm = anchoMm * 0.55;
    var ancho = anchoMm * escala, alto = altoMm * escala;
    var y = CY + rTxt;
    this.svg.setAttribute('viewBox',
      (CX - ancho / 2).toFixed(1) + ' ' + (y - alto * 0.62).toFixed(1) + ' ' + ancho.toFixed(1) + ' ' + alto.toFixed(1));
    var x0 = CX - ancho / 2 + ancho * 0.05, yy = y + alto * 0.30;
    q(this.svg, '[data-gl-regla-linea]').setAttribute('d',
      'M ' + x0 + ',' + (yy - 2) + ' v4 M ' + x0 + ',' + yy + ' h ' + escala + ' M ' + (x0 + escala) + ',' + (yy - 2) + ' v4');
    var t = q(this.svg, '[data-gl-regla-txt]');
    t.setAttribute('x', (x0 + escala / 2).toFixed(1));
    t.setAttribute('y', (yy - 3.5).toFixed(1));
    t.setAttribute('font-size', Math.max(3, alto * 0.1).toFixed(1));
    reg.setAttribute('opacity', '1');
  };

  Config.prototype.marcado = function (texto) {
    var out = '';
    texto = texto || '';
    for (var i = 0; i < texto.length; i++) {
      var c = texto[i];
      out += SIMBOLOS[c] ? '[' + SIMBOLOS[c] + ']' : c;
    }
    return limpio(out);
  };

  Config.prototype.fila = function (dl, etiqueta, valor, clase) {
    var dt = document.createElement('dt'); dt.textContent = etiqueta;
    var dd = document.createElement('dd'); dd.textContent = valor;
    if (clase) dd.className = clase;
    dl.appendChild(dt); dl.appendChild(dd);
  };

  Config.prototype.bloqueResumen = function (a, i) {
    var e = this.estado, dos = e.cantidad === 2;
    var d = document.createElement('div');
    d.className = 'gl__bloque';
    if (dos) {
      var h = document.createElement('p');
      h.className = 'gl__bloque-t';
      h.textContent = 'Anillo ' + (i + 1) + (a.ident ? ' · ' + a.ident : '');
      d.appendChild(h);
    }
    var dl = document.createElement('dl');
    dl.className = 'gl__dl';
    this.fila(dl, 'Texto', this.marcado(a.texto) || '—');
    if (!dos && a.ident) this.fila(dl, 'Anillo', a.ident);
    this.fila(dl, 'Anillo', (a.talla ? 'talla ' + a.talla + ' · ' : '') + mm(a.banda) + ' mm de ancho');
    var alto = a.banda >= num(this.cfg.umbralBanda, 2.5)
      ? num(this.cfg.altoLetraAncha, 1.75) : num(this.cfg.altoLetraFina, 0.85);
    this.fila(dl, 'Letra de', mm(alto) + ' mm de alto');
    if (SUPERFICIES[a.superficie]) this.fila(dl, 'Superficie', SUPERFICIES[a.superficie]);
    d.appendChild(dl);
    return d;
  };

  Config.prototype.resumen = function (fam) {
    var r = this.raiz, e = this.estado;
    var cont = q(r, '[data-gl-resumen]');
    cont.innerHTML = '';
    for (var i = 0; i < e.cantidad; i++) cont.appendChild(this.bloqueResumen(e.anillos[i], i));

    var dl = document.createElement('dl');
    dl.className = 'gl__dl gl__dl--comun';
    this.fila(dl, 'Letra', fam || '—');
    this.fila(dl, 'Ubicación', 'Interior del anillo');
    this.fila(dl, 'Código', this.id, 'gl__id');
    cont.appendChild(dl);

    var p = num(this.cfg.precio, 350), mon = this.cfg.moneda || 'L';
    q(r, '[data-gl-r-precio]').textContent = e.cantidad > 1
      ? mon + p + ' × ' + e.cantidad + ' anillos = ' + mon + (p * e.cantidad)
      : mon + p + ' por anillo';

    var todoTexto = '';
    for (i = 0; i < e.cantidad; i++) todoTexto += e.anillos[i].texto;

    var av = q(r, '[data-gl-aviso-fuente]');
    if (limpio(todoTexto) && fam) {
      cargarFuente(fam, todoTexto).then(function () {
        var falta = glifosFaltantes(fam, todoTexto);
        if (falta.length) {
          av.setAttribute('data-tono', 'stop');
          av.textContent = 'La letra «' + fam + '» no trae ' +
            falta.map(function (c) { return '«' + c + '»'; }).join(', ') +
            '. En pantalla se ve bien porque el navegador la sustituye, pero al grabar saldría distinto. Elegí otra letra.';
        } else { av.removeAttribute('data-tono'); av.textContent = ''; }
      });
    } else { av.removeAttribute('data-tono'); av.textContent = ''; }

    var enlace = q(r, '[data-gl-wa]'), lbl = q(r, '[data-gl-wa-label]');
    var faltan = [];
    for (i = 0; i < e.cantidad; i++) if (!limpio(e.anillos[i].texto)) faltan.push(i + 1);
    if (faltan.length) {
      enlace.setAttribute('aria-disabled', 'true');
      enlace.setAttribute('href', '#');
      lbl.textContent = e.cantidad > 1
        ? 'Escribí el texto del anillo ' + faltan.join(' y el del anillo ')
        : 'Escribí tu texto para continuar';
      return;
    }
    enlace.removeAttribute('aria-disabled');
    lbl.textContent = 'Enviar mi diseño por WhatsApp';
    enlace.setAttribute('href', 'https://wa.me/' + this.cfg.whatsapp + '?text=' +
      this.mensaje(fam).map(encodeURIComponent).join('%0A'));
    persistirDiseno();
  };

  /* Plantilla del mensaje de WhatsApp.
     🔴 L1 la lee para capturar el pedido. Si cambia, avisar a L1 ANTES. */
  Config.prototype.mensaje = function (fam) {
    var e = this.estado, self = this;
    var mon = this.cfg.moneda || 'L', p = num(this.cfg.precio, 350);
    var l = ['Hola, preparé mi diseño de grabado #' + this.id + '.'];
    l.push('Ubicación: Interior del anillo');
    l.push('Letra: ' + fam);
    if (e.cantidad > 1) l.push('Son ' + e.cantidad + ' anillos:');
    for (var i = 0; i < e.cantidad; i++) {
      var a = e.anillos[i];
      if (e.cantidad > 1) {
        l.push('');
        l.push('Anillo ' + (i + 1) + (a.ident ? ' · ' + a.ident : ''));
      }
      l.push('Texto: ' + self.marcado(a.texto));
      if (e.cantidad === 1 && a.ident) l.push('Anillo: ' + a.ident);
      if (a.talla) l.push('Talla: ' + a.talla);
      l.push('Ancho del anillo: ' + a.banda + ' mm');
      if (a.superficie === 'piedras') l.push('El anillo lleva piedras.');
      if (a.superficie === 'eternity') l.push('El anillo lleva piedras en todo el contorno.');
      if (limpio(a.texto).length > this.max) {
        l.push('(Este texto pasa de ' + this.max + ' caracteres — por favor confírmenme si cabe.)');
      }
    }
    l.push('');
    l.push('Servicio de grabado: ' + (e.cantidad > 1
      ? mon + p + ' × ' + e.cantidad + ' = ' + mon + (p * e.cantidad)
      : mon + p));
    l.push('Me gustaría continuar con mi pedido.');
    return l;
  };

  function iniciar() {
    qa(document, '[data-gl]').forEach(function (r) {
      if (r.dataset.glListo) return;
      r.dataset.glListo = '1';
      try { new Config(r); } catch (err) {
        if (window.console) console.error('[grabado-laser]', err);
      }
    });
    ajustarTope();
  }

  var pendiente = false;
  function alMoverse() {
    if (pendiente) return;
    pendiente = true;
    (window.requestAnimationFrame || setTimeout)(function () { pendiente = false; ajustarTope(); }, 16);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', iniciar);
  else iniciar();
  document.addEventListener('shopify:section:load', iniciar);
  window.addEventListener('load', ajustarTope);
  window.addEventListener('resize', alMoverse);
  window.addEventListener('scroll', alMoverse, { passive: true });
  window.addEventListener('orientationchange', alMoverse);
  setTimeout(ajustarTope, 800);
  window.GLGrabado = { iniciar: iniciar, ajustarTope: ajustarTope };
})();